import type { BackendTournament, TransformedTournament } from './types';

export const transformTournament = (entry: BackendTournament): TransformedTournament => {
  return {
    id: entry.id,
    sportId: entry.sportId,
    tournamentUnionId: entry.tournamentUnionId,
    name: entry.name,
    icon: entry.icon,
    priority: entry.priority,
    promotionLevel: entry.promotionLevel,
  };
};
